import { render, staticRenderFns } from "./ItemNotes.vue?vue&type=template&id=71b92c0c"
import script from "./ItemNotes.vue?vue&type=script&lang=js"
export * from "./ItemNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports